import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import i18n from "@/i18n";

const LangContext = createContext(null);
const KEY = "bizarre_lang";

// Sélecteur de langue GLOBAL (fr|en), mémorisé sur le compte utilisateur + localStorage.
// Base définitive du système multilingue : pilote react-i18next (i18n.changeLanguage) pour
// traduire toute l'interface (menus, boutons, titres, messages, espaces Enfant/Ado/Parent/Adulte).
export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem(KEY) || "fr");

  // Applique la langue à i18next au montage.
  useEffect(() => { if (i18n.language !== lang) i18n.changeLanguage(lang); }, []); // eslint-disable-line

  // Adopte la langue mémorisée sur le compte dès que l'utilisateur est chargé.
  useEffect(() => {
    if (user && user.lang && user.lang !== lang) {
      setLangState(user.lang);
      localStorage.setItem(KEY, user.lang);
      i18n.changeLanguage(user.lang);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const setLang = useCallback(async (l) => {
    if (l !== "fr" && l !== "en") return;
    setLangState(l);
    localStorage.setItem(KEY, l);
    i18n.changeLanguage(l);
    if (user) { try { await api.post("/account/language", { lang: l }); } catch (_) {} }
  }, [user]);

  return <LangContext.Provider value={{ lang, setLang }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext) || { lang: "fr", setLang: () => {} };

